/*
 * Managed WordPress Hosting Alternatives — Index Page JavaScript
 * Entry point for the alternatives index landing page.
 * Uses Edge build system (Vite + Tailwind 4).
 */

import './alternatives-index.css';

// Shared utilities (nav, topbar, coupon bar, mobile + mega menu)
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';
import '../shared/mega-menu.js';

// Scroll-triggered fade-in animations ([data-fade-in])
import '../shared/landing/animations.js';

document.addEventListener('DOMContentLoaded', () => {
  console.log('Alternatives index page loaded (Edge/Vite bundle)');
});
